import { render, staticRenderFns } from "./OtrosDocumentos.vue?vue&type=template&id=50b07558&"
import script from "./OtrosDocumentos.vue?vue&type=script&lang=js&"
export * from "./OtrosDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports